import { AxiosResponse } from 'axios';
// src/redux/saga/groupSaga.ts
import { put, takeLatest } from 'redux-saga/effects';
import { callPlannerEndPoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

import {
  CallCampaign,
  fetchCallCampaign,
  fetchCallCampaignFailure,
  fetchCallCampaignSuccess,
} from './../../slice/callCampaign/CallCampaign.slice';

function* fetchCallCampaignSaga(action: any) {
  try {
    const { agencyId } = action.payload;
    const response: AxiosResponse<CallCampaign[]> = yield HTTPClient.GetRequest(
      `${callPlannerEndPoints.GET_CAMPAIGNS(agencyId)}`
    );
    yield put(fetchCallCampaignSuccess(response.data));
  } catch (error) {
    yield put(fetchCallCampaignFailure('Failed to fetch groups'));
  }
}

// function* saveGroupSaga(action: PayloadAction<ISaveGroupRequest>) {
//     try {
//       const groupData = action.payload;
//       groupData.supervisor_id = '66f55e4ba79d8b001c1eac5a';
//       const response: AxiosResponse<ISaveGroupResponse> = yield HTTPClient.PostRequest(
//         callCampaignEndpoints.SAVE_GROUP(),
//         groupData,
//       );
//       yield put(saveGroupSuccess(response.data));
//     } catch (error: any) {
//       yield put(saveGroupFailure(error?.message));
//     }
//   }

export function* watchFetchCallCampaignSagas() {
  yield takeLatest(fetchCallCampaign.type, fetchCallCampaignSaga);
  //   yield takeLatest(
  //     saveGroup.type,
  //     saveGroupSaga
  //   );
}
